import { render, staticRenderFns } from "./ProductOrdersChildrens.vue?vue&type=template&id=654e3706"
import script from "./ProductOrdersChildrens.vue?vue&type=script&lang=js"
export * from "./ProductOrdersChildrens.vue?vue&type=script&lang=js"
import style0 from "./ProductOrdersChildrens.vue?vue&type=style&index=0&id=654e3706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports